{{#if hasPolicies}}
function void add_policy(policy_base_c#({{ thisType }}) policy);
  policy.set_object(this);
  policies.push_back(policy);
endfunction
{{/if}}
